// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logs-admin {
  width: min(96vw, 1000px);
  max-height: 86vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logs-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.logs-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.logs-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.logs-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.logs-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.logs-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.logs-admin__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
  flex-wrap: wrap;
}

.logs-admin__meta {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.logs-admin__file {
  color: #eef4fb;
  font-weight: 600;
  font-size: 0.9rem;
}

.logs-admin__sub {
  color: #9fb4cc;
  font-size: 0.78rem;
}

.logs-admin__badge {
  align-self: flex-start;
  margin-top: 0.2rem;
  padding: 0.1rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 190, 90, 0.15);
  border: 1px solid rgba(255, 190, 90, 0.4);
  color: #ffd399;
  font-size: 0.72rem;
}

.logs-admin__error {
  margin-bottom: 0.9rem;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  background: rgba(255, 90, 90, 0.12);
  border: 1px solid rgba(255, 90, 90, 0.4);
  color: #ffb3b3;
  font-size: 0.85rem;
}

.logs-admin__status {
  padding: 1rem 0;
  color: #9fb4cc;
  font-size: 0.9rem;
}

.logs-admin__content {
  margin: 0;
  padding: 0.9rem 1rem;
  background: #0f1826;
  border: 1px solid rgba(74, 158, 255, 0.2);
  border-radius: 8px;
  color: #cdd8e6;
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  font-size: 0.78rem;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-y: auto;
  max-height: 62vh;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.logs-admin__content::-webkit-scrollbar { width: 8px; }
.logs-admin__content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/logs-admin-panel/logs-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,2BAA2B,aAAa,EAAE,cAAc,EAAE;;AAE1D;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,+DAA+D;EAC/D,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA,0CAA0C,UAAU,EAAE;AACtD;EACE,qCAAqC;EACrC,kBAAkB;AACpB","sourcesContent":[".logs-admin {\r\n  width: min(96vw, 1000px);\r\n  max-height: 86vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.logs-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.logs-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.logs-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.logs-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.logs-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.logs-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n.logs-admin__toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.9rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.logs-admin__meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.logs-admin__file {\r\n  color: #eef4fb;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.logs-admin__sub {\r\n  color: #9fb4cc;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.logs-admin__badge {\r\n  align-self: flex-start;\r\n  margin-top: 0.2rem;\r\n  padding: 0.1rem 0.5rem;\r\n  border-radius: 999px;\r\n  background: rgba(255, 190, 90, 0.15);\r\n  border: 1px solid rgba(255, 190, 90, 0.4);\r\n  color: #ffd399;\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.logs-admin__error {\r\n  margin-bottom: 0.9rem;\r\n  padding: 0.6rem 0.8rem;\r\n  border-radius: 6px;\r\n  background: rgba(255, 90, 90, 0.12);\r\n  border: 1px solid rgba(255, 90, 90, 0.4);\r\n  color: #ffb3b3;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.logs-admin__status {\r\n  padding: 1rem 0;\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.logs-admin__content {\r\n  margin: 0;\r\n  padding: 0.9rem 1rem;\r\n  background: #0f1826;\r\n  border: 1px solid rgba(74, 158, 255, 0.2);\r\n  border-radius: 8px;\r\n  color: #cdd8e6;\r\n  font-family: ui-monospace, \"Cascadia Code\", Consolas, monospace;\r\n  font-size: 0.78rem;\r\n  line-height: 1.45;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  overflow-y: auto;\r\n  max-height: 62vh;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.logs-admin__content::-webkit-scrollbar { width: 8px; }\r\n.logs-admin__content::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.25);\r\n  border-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
